import React, { Component } from "react";
import { connect } from "react-redux";
import { compose, withApollo, Query } from "react-apollo";
import { reduxForm } from "redux-form";
import {
  OnboardingHeader,
  Theme,
  Button,
  PackageSelector
} from "../../../globalComponents/";
import { submitHandler } from "../../../globalComponents/FetchComponents/PackageForm";
import { USER_DETAILS, DOG_DETAILS } from "../../../store/queries.js";
import { withRouter } from 'react-router-dom';
import queryString from 'query-string';

class Packages extends Component {
  constructor(props) {
    super(props)

    const { dogId } = queryString.parse(props.location.search);
    console.log("[Packages] Constructor - dogId from URL:", dogId)
    this.state = {
      dogId,
      submitting: false
    }
  }

  setSubmitting = (submitting) => {
    this.setState({ submitting });
  }

  componentDidMount() {
    console.log("[Packages] componentDidMount - dogId:", this.state.dogId)
    this.props.change("dogId", this.state.dogId);
  }

  componentDidUpdate(prevProps, prevState) {
    console.log("[Packages] componentDidUpdate", {
      prevDogId: prevState.dogId,
      currentDogId: this.state.dogId,
      propsChanged: prevProps !== this.props
    })
  }

  getId() {
    const {
      global: { currentUser }
    } = this.props;
    if (currentUser.selectedUser) {
      return currentUser.selectedUser;
    } else {
      return currentUser.id;
    }
  }

  onSkip = () => {
    this.props.history.push("payment");
  };

  renderUserCurrentPackage(loading, error, data, refetch, width) {
    return (<div>
      {!loading && !error && data?.userDetail && data.userDetail.package && (
        <div
          style={{
            marginBottom: "2%",
            marginTop: "5%",
            textAlign: "center",
            fontFamily: Theme.HEADER_FONT,
            fontSize: Theme.getHeaderFont(width),
            color: Theme.HEADER_FONT_COLOR
          }}
        >
          Current Package: {data.userDetail.package.name}
        </div>
      )}
    </div>)
  }

  renderDogCurrentPackage(loading, error, data, refetch, width) {
    return (<div>
      {!loading && !error && data?.dogDetail?.package && (
        <div
          style={{
            marginBottom: "2%",
            marginTop: "5%",
            textAlign: "center",
            fontFamily: Theme.HEADER_FONT,
            fontSize: Theme.getHeaderFont(width),
            color: Theme.HEADER_FONT_COLOR
          }}
        >
          Current package for {data.dogDetail.name}: {data.dogDetail.package.name}
        </div>
      )}
    </div>)
  }

  handleSave = () => {
    const { handleSubmit } = this.props;
    const { submitting } = this.state;

    if (submitting) {
      console.log("[Packages] handleSave blocked - already submitting");
      return;
    }

    console.log("[Packages] handleSave - setting submitting=true");
    this.setSubmitting(true);

    handleSubmit((values) => formSubmit(values, null, {
      ...this.props,
      setSubmitting: this.setSubmitting
    }))();
  }

  render() {
    const {
      dimensions: { height, width }
    } = this.props.global || {
      dimensions: { height: 0, width: 1000 }
    },
      { handleSubmit, history } = this.props;
    const { submitting } = this.state;

    console.log("[Packages] render() - dogId:", this.state.dogId, "submitting:", submitting, "Query type:", this.state.dogId ? "DOG_DETAILS" : "USER_DETAILS");

    return (
      <Query
        fetchPolicy="no-cache"
        query={this.state.dogId ? DOG_DETAILS : USER_DETAILS}
        variables={{ id: this.state.dogId ? this.state.dogId : this.getId() }}
      >
        {({ loading, error, data, refetch }) => {
          console.log("[Packages] Query render callback", {
            loading,
            hasError: !!error,
            errorMsg: error?.message,
            hasData: !!data,
            dataKeys: data ? Object.keys(data) : []
          });
          return (
          <OnboardingHeader
            back={() => history.push("/staff/member")}
            progress={false}
            containerStyle={{}}
            checkInStatus={false}
          >

            {
              this.state.dogId ? this.renderDogCurrentPackage(loading, error, data, refetch, width) : this.renderUserCurrentPackage(loading, error, data, refetch, width)
            }

            <PackageSelector
              {...{ width, height }}
              hiddenPackages={true}
              onChange={pack => {
                console.log("[Packages] PackageSelector onChange", { packageId: pack.id, recurring: pack.recurring });
                this.props.change("packageId", pack.id);
                this.props.change("isRecurring", pack.recurring);
              }}
              dogId={this.state.dogId}
            />
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "center",
                marginLeft: "auto",
                marginRight: "auto",
                marginBottom: "5%",
                width: Theme.getLongInputWidth(width),
                marginTop: "5%"
              }}
            >
              <Button
                text="Skip"
                containerStyle={{ marginLeft: "0.5em", marginRight: "0.5em" }}
                alt={true}
                width={width}
                onClick={this.onSkip}
              />
              <Button
                containerStyle={{ marginLeft: "0.5em", marginRight: "0.5em" }}
                text="Save and Continue"
                width={width}
                onClick={this.handleSave}
                loading={submitting}
                loadingText="Saving..."
                disabled={submitting}
              />
            </div>
          </OnboardingHeader>
        )}}
      </Query>
    );
  }
}

const mapStateToProps = state => ({ ...state.global }),
  formSubmit = (values, dispatch, props) => {
    console.log("[Packages] ** formSubmit START **", { values, props })
    const { dogId, packageId, isRecurring } = values || {};
    const { setSubmitting } = props;
    console.log("[Packages] formSubmit extracted values:", { dogId, packageId, isRecurring })

    const onUserUpdated = isRecurring => {
      console.log("[Packages] onUserUpdated called with isRecurring:", isRecurring);
      if (setSubmitting) setSubmitting(false);
      if (isRecurring) {
        console.log("[Packages] Navigating to /staff/member/recurring");
        props.history.push("/staff/member/recurring");
      } else {
        console.log("[Packages] Navigating to payment");
        props.history.push("payment");
      }
    };

    const onDogUpdated = isRecurring => {
      console.log("[Packages] onDogUpdated called with isRecurring:", isRecurring)
      if (setSubmitting) setSubmitting(false);
      const url = isRecurring
        ? `/staff/member/recurring?dogId=${dogId}&packageId=${packageId}&isRecurring=${isRecurring}`
        : `payment?dogId=${dogId}&packageId=${packageId}&isRecurring=${isRecurring}`;
      console.log("[Packages] Navigating to:", url);
      if (isRecurring) {
        props.history.push(url);
      } else {
        props.history.push(url);
      }
    };

    console.log("[Packages] Calling submitHandler with callback:", dogId ? "onDogUpdated" : "onUserUpdated");
    return submitHandler(values, props, null, dogId ? onDogUpdated : onUserUpdated);
  };

Packages = reduxForm({
  form: "Packages",
  onSubmit: formSubmit
})(Packages);

export default compose(
  withApollo,
  withRouter,
  connect(mapStateToProps)
)(Packages);
